/* -------------------------------------------------------------------------- */
/*  Viewpoint Vista family renderer                                             */
/* -------------------------------------------------------------------------- *
 *  Vista imports aggregate the estimate into job-cost records (phase, cost     *
 *  type, contract item), and each tenant's import template picks its own       *
 *  delimiter and columns, so the tenant owns the full body. This is the seam   *
 *  where a shared record walk goes once two Vista tenants want the same one.   */
/* -------------------------------------------------------------------------- */

import { BudgetImportConfig, BudgetImportContext } from "../types";

export function renderVista(ctx: BudgetImportContext, config: BudgetImportConfig): string[] {
  if (config.format !== "vista") throw new Error(`renderVista received a ${config.format} config`);
  return config.vista.render(ctx);
}
